import { SITE } from "@/constants/site";
import conseils from "./conseils-fr";

/* Version française — texte de référence du site. */
const fr = {
    nav: {
        approche: "L'approche",
        soins: "Les soins",
        tarifs: "Les tarifs",
        cabinet: "Le cabinet",
        medecin: "Le médecin",
        faq: "FAQ",
        conseils: "Conseils",
        rdvShort: "Rendez-vous",
        rdvLong: "Prendre rendez-vous",
        langAria: "Choisir la langue",
    },
    common: {
        rdvOn: "Prendre rendez-vous sur",
        viewMaps: "Voir sur Google Maps",
        readMore: "En savoir plus",
        home: "Accueil",
        breadcrumbAria: "Fil d'Ariane",
        hoursTitle: "Horaires d'ouverture",
        faqTitle: "Questions fréquentes",
        rdvTitle: "Prendre rendez-vous",
        conseilsLink: "Lire les conseils avant et après un soin",
        closed: "Fermé",
    },
    beforeAfter: {
        before: "Avant",
        after: "Après",
        compare: "Comparer avant et après :",
    },
    hours: {
        days: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
        range: "10h30 – 17h30",
        compactStrong: "Lundi, mardi, jeudi et vendredi",
        compactRest: "de 10h30 à 17h30 — fermé le mercredi, le samedi et le dimanche.",
    },
    hero: {
        eyebrow: "Dr Souhali · Médecin · Asnières-sur-Seine",
        h1: "Vos hormones, votre peau, vos cheveux. Un seul suivi.",
        sub: "Votre cabinet médical esthétique à Asnières-sur-Seine.",
        specialites:
            "Médecine esthétique · anti-âge · épilation laser et électrolyse · injections d'acide hyaluronique · skinboosters · inducteurs de collagène · peelings · microneedling · acné · mélasma · santé intime",
        cta: "Prendre rendez-vous",
        link: "Voir les soins",
        doctolibMention: "Rendez-vous en ligne sur",
        photoAlt:
            "L'accueil de la clinique : mur terre cuite, médaillon doré Aurassium et canapé crème",
    },
    approche: {
        eyebrow: "L'approche",
        h2: "Quand vos hormones se voient sur votre peau",
        lead: "Avant de traiter ce qui se voit, on comprend d'où cela vient.",
        paragraphes: [
            "Le Dr Souhali Massilia, médecin généraliste, esthétique, anti-âge et santé de la femme, vous accueille pour une prise en charge globale.",
            "Nous traitons les effets visibles des troubles hormonaux (SOPK, ménopause) : acné, chute de cheveux, pilosité excessive. L'hirsutisme est pris en charge au cabinet, par laser et électrolyse.",
            "Nous prenons aussi soin de votre santé intime, notamment de la sécheresse intime.",
            "Nous proposons l'épilation laser, les injections d'acide hyaluronique, les skinboosters, les inducteurs de collagène, les peelings et le microneedling.",
        ],
        conclusion:
            "Une approche combinant exigence médicale, accompagnement et suivi personnalisés.",
        prompt: "Vous vous reconnaissez ?",
        items: [
            ["SOPK", "Acné, pilosité qui s'installe (hirsutisme), cheveux qui tombent, cycles irréguliers."],
            ["Périménopause et ménopause", "Peau plus fine et plus sèche, perte de fermeté, inconfort intime."],
            ["Endométriose", "Les effets de votre traitement hormonal sur votre peau et vos cheveux."],
            ["Troubles androgéniques", "Pilosité sur le visage et le corps, acné, cheveux qui perdent en densité."],
            ["Après une variation de poids", "Qualité de peau et relâchement après une prise ou une perte de poids."],
            ["Une prise en charge globale", "Un seul médecin regarde votre terrain hormonal, votre peau et vos cheveux."],
        ],
    },
    parcours: {
        eyebrow: "Le parcours",
        h2: "Comment ça se passe",
        lead: "Trois étapes simples : on parle, on examine, on décide ensemble. Rien n'est décidé avant la consultation.",
        photoAlt:
            "Un plan de travail blanc sous cinq planches anatomiques fleuries : cerveau, visage, poumons, cœur",
        photoLegend: "Le poste d'analyse de la peau, sous les planches anatomiques",
        steps: [
            ["La consultation", "on parle de vos signes, de votre histoire et de ce qui vous gêne."],
            ["Le bilan", "si besoin, le médecin prescrit un bilan hormonal et les examens utiles."],
            ["Le plan", "suivi médical, soins de la peau, des cheveux ou de la pilosité. On choisit ensemble."],
        ],
    },
    soinsSection: {
        eyebrow: "Nos prestations",
        h2: "Les soins",
        lead: "Suivi hormonal et médecine esthétique au même endroit. Chaque acte est réalisé ou supervisé par un médecin.",
        photoAlt: "La salle de soins : table de soin, laser et grandes fenêtres",
        photoLegend: "La salle de soins",
        familles: [
            ["Suivi hormonal", ["consultation SOPK et troubles hormonaux", "périménopause et ménopause", "bilan des signes liés aux hormones"], "sopk"],
            ["Épilation laser et électrolyse", ["pilosité liée au SOPK et hirsutisme", "visage et corps", "électrolyse pour les poils clairs", "séances par zone ou plusieurs zones"], "epilation-laser"],
            ["Cheveux", ["bilan de la chute de cheveux", "mésothérapie du cuir chevelu"], "chute-de-cheveux"],
            ["Qualité de peau", ["peeling superficiel et moyen", "mésothérapie", "microneedling", "skinbooster", "mélasma et taches pigmentaires"], "peau-et-rides"],
            ["Rides et relâchement", ["injections d'acide hyaluronique", "inducteurs de collagène", "fils inducteurs de collagène"], "acide-hyaluronique"],
            ["Santé intime", ["sécheresse de la zone intime", "atrophie de la zone intime"], "sante-intime"],
        ],
        detailTitle: "En détail, motif par motif",
        illustrations: {
            eyebrow: "Illustrations médicales",
            h3: "Ce que l'on cherche à obtenir",
            lead: "Trois motifs de consultation fréquents. Faites glisser le curseur pour comparer l'avant et l'après.",
            items: {
                levres: {
                    title: "Lèvres — acide hyaluronique",
                    note: "Hydratation et dessin du contour, en une séance. Volume mesuré, jamais figé.",
                    beforeAlt: "Illustration : lèvres fines, contour peu dessiné, avant injection",
                    afterAlt: "Illustration : lèvres hydratées au contour redessiné, après injection d'acide hyaluronique",
                },
                melasma: {
                    title: "Mélasma — taches pigmentaires",
                    note: "Protocole dépigmentant, peelings et photoprotection sur plusieurs mois.",
                    beforeAlt: "Illustration : taches brunes du mélasma sur les pommettes et le front",
                    afterAlt: "Illustration : teint homogène après traitement du mélasma",
                },
                cheveux: {
                    title: "Chute de cheveux — densité",
                    note: "Bilan de la cause, puis mésothérapie du cuir chevelu et traitement de fond.",
                    beforeAlt: "Illustration : raie élargie et cuir chevelu visible, chute de cheveux",
                    afterAlt: "Illustration : densité capillaire retrouvée, raie resserrée",
                },
            },
            disclaimer:
                "Images d'illustration à visée pédagogique. Elles ne représentent pas de patientes de la clinique et ne constituent pas une promesse de résultat.",
        },
        footnote:
            "Les résultats varient d'une personne à l'autre. Tout vous est expliqué avant de commencer. Pour les actes esthétiques, un devis écrit est remis et un délai de réflexion est respecté.",
    },
    tarifsSection: {
        eyebrow: "En toute transparence",
        h2: "Les tarifs",
        lead: "Des prix clairs, annoncés avant de commencer. Pour tout acte esthétique, un devis écrit vous est remis, expliqué et décidé avec vous.",
        apercuTitle: "Les soins, en bref",
        apercu: [
            ["Épilation laser", "à partir de 30 € la zone"],
            ["Peelings et microneedling", "de 120 € à 200 €"],
            ["Mésothérapie, cheveux et peau", "à partir de 150 €"],
            ["Acide hyaluronique", "à partir de 350 € la seringue"],
            ["Inducteurs de collagène", "à partir de 400 €"],
            ["Santé intime", "à partir de 350 €"],
        ],
        detailLink: "Voir le détail des tarifs",
        note: "Les actes de médecine esthétique ne sont pas remboursés par l'Assurance maladie. Un délai de réflexion est respecté avant tout acte.",
    },
    lieu: {
        eyebrow: "Le lieu",
        h2: "Le lieu",
        lead: "Un cabinet calme à Asnières-sur-Seine, lumineux et chaleureux, pensé pour que vous soyez à l'aise.",
        photos: [
            ["cafe.jpg", "Le coin café, avec une étagère en arche terracotta et un olivier", "Le coin café"],
            ["peau.jpg", "Un olivier et deux cadres terracotta au mur", "Le coin olivier"],
            ["bureau.jpg", "Une cabine de soins avec sa table de soin, ses appareils et les diplômes du médecin encadrés au mur", "La cabine de soins"],
        ],
        detailLink: "Voir le cabinet et l'accès",
    },
    medecinSection: {
        eyebrow: "Le médecin",
        h2: "Dr Souhali Massilia",
        lead: "Médecin fondatrice d'Aurassium Clinic.",
        photoAlt: "Portrait du Dr Souhali Massilia, médecin, en tenue médicale",
        formationButton: "Formation réalisée",
        rpps: `N° RPPS ${SITE.rpps}`,
        detailLink: "Voir le parcours détaillé",
    },
    formation: {
        dialogTitle: "Formation",
        subtitle: `${SITE.doctor}, médecin diplômée d'État · N° RPPS ${SITE.rpps}`,
        closeLabel: "Fermer",
        diplomesTitle: "Diplômes nationaux et universitaires",
        autresTitle: "Autres formations",
        diplomes: [
            ["2025", "D.U. Techniques d'injection et de comblement", "Université Paris-Est Créteil Val-de-Marne (UPEC)"],
            ["2024", "D.U. Médecine esthétique", "Université Paris-Sud (Paris 11)"],
            ["2022", "Capacité de médecine de gérontologie", "Sorbonne Université, faculté de médecine (Paris VI)"],
        ],
        autres: [
            ["2025", "Formation en oculoplastie esthétique", "UPEC"],
            ["2024", "Collège international de médecine esthétique", "Paris"],
        ],
        expertises: [
            "Troubles hormonaux féminins",
            "Médecine esthétique",
            "Épilation laser",
            "Santé de la peau et des cheveux",
        ],
    },
    faq: {
        eyebrow: "Questions fréquentes",
        h2: "Ce que les patientes demandent le plus",
        lead: "Les réponses aux questions posées avant un premier rendez-vous.",
        items: [
            [
                "Qu'est-ce que le SOPK ?",
                "Le syndrome des ovaires polykystiques est un déséquilibre hormonal fréquent. Il se traduit souvent par des cycles irréguliers, de l'acné, une pilosité excessive ou une chute de cheveux. Le diagnostic repose sur un entretien, un examen clinique et un bilan hormonal.",
            ],
            [
                "Comment savoir si ma peau ou mes cheveux réagissent à un trouble hormonal ?",
                "Acné persistante à l'âge adulte, poils du visage, cheveux qui s'affinent sur le dessus du crâne ou taches brunes qui reviennent : ce sont des signes qui méritent un bilan. La consultation cherche la cause avant de traiter le signe.",
            ],
            [
                "Comment se passe la première consultation ?",
                "Elle se déroule en trois temps : on parle de vos signes et de votre histoire, le médecin examine la peau, les cheveux et la pilosité, puis vous décidez ensemble du plan. Rien n'est décidé ni réalisé avant cet échange.",
            ],
            [
                "Faut-il une lettre de mon médecin traitant pour venir ?",
                "Non. Le rendez-vous se prend directement en ligne sur Doctolib. Apportez vos derniers bilans sanguins si vous en avez, ainsi que la liste de vos traitements.",
            ],
            [
                "Quels soins sont proposés au cabinet ?",
                "Suivi du SOPK et des troubles hormonaux, périménopause et ménopause, bilan de la chute de cheveux, épilation laser et électrolyse du visage et du corps, qualité de peau (peeling, mésothérapie, microneedling, skinbooster), traitement du mélasma, injections d'acide hyaluronique, inducteurs de collagène et santé intime.",
            ],
            [
                "Hirsutisme : laser ou électrolyse ?",
                "Les deux sont pratiqués au cabinet, souvent en complément. Le laser traite efficacement les poils foncés sur de grandes zones ; l'électrolyse prend le relais sur les poils clairs, blancs ou résistants, poil par poil. Le choix se fait après examen de la zone et du type de poil.",
            ],
            [
                "Que proposez-vous pour la sécheresse intime ?",
                "La sécheresse et l'inconfort intimes sont fréquents à la ménopause ou sous traitement hormonal. La consultation évalue la situation et propose une prise en charge médicale adaptée, éventuellement complétée par un soin au cabinet.",
            ],
            [
                "Les actes de médecine esthétique sont-ils remboursés ?",
                "Non, les actes de médecine esthétique ne sont pas pris en charge par l'Assurance maladie. Un devis est remis et un délai de réflexion est respecté avant tout acte.",
            ],
            [
                "Où se trouve le cabinet ?",
                "Au 10 rue Vladimir Kramnik, 92600 Asnières-sur-Seine, à proximité de Clichy, Bois-Colombes, Courbevoie et Levallois-Perret.",
            ],
        ],
    },
    rdv: {
        eyebrow: "Rendez-vous",
        h2: "Prendre rendez-vous",
        lead: "En ligne, sur Doctolib. Pour un premier rendez-vous, choisissez « première consultation ».",
        onlineTitle: "En ligne",
        onlineText: "Au nom du Dr Souhali, à Asnières-sur-Seine.",
        addressTitle: "Adresse",
    },
    footer: {
        doctorLine: `© 2026 ${SITE.name} · ${SITE.doctor}, médecin`,
        rpps: `N° RPPS ${SITE.rpps}`,
        legal: "Mentions légales",
        privacy: "Confidentialité",
        instagramAria: "Instagram d'Aurassium Clinic",
    },
    tarifsData: {
        consultations: [
            ["Consultation", "60 €", "Premier rendez-vous ou suivi"],
            ["Consultation SOPK", "70 €", "Bilan hormonal complet"],
        ],
        soinsA: [
            ["Qualité de peau", [
                ["Peeling superficiel", "150 €"],
                ["Peeling moyen", "200 €"],
                ["Mésothérapie", "150 €"],
                ["Microneedling", "120 €"],
                ["Skinbooster", "300 € (la séance)"],
            ]],
            ["Cheveux", [["Mésothérapie du cuir chevelu, la séance", "à partir de 150 €"]]],
        ],
        soinsB: [
            ["Rides et relâchement", [
                ["Acide hyaluronique, la seringue", "à partir de 350 €"],
                ["Inducteurs de collagène, la séance", "à partir de 400 €"],
                ["Fils inducteurs de collagène", "à partir de 500 €"],
            ]],
            ["Santé intime", [
                ["Sécheresse de la zone intime, la séance", "350 €"],
                ["Atrophie de la zone intime", "sur devis"],
            ]],
        ],
        laser: [
            ["Une seule zone", [
                ["Intersourcil", "30 €"],
                ["Lèvre supérieure", "40 €"],
                ["Aisselles", "50 €"],
                ["Aréoles", "50 €"],
                ["Mains", "30 €"],
                ["Avant-bras et mains", "80 €"],
                ["Bras entiers", "150 €"],
                ["Maillot classique", "80 €"],
                ["Maillot échancré", "100 €"],
                ["Maillot brésilien", "120 €"],
                ["Maillot intégral", "150 €"],
                ["Sillon interfessier", "50 €"],
                ["Demi-jambes, genoux inclus", "110 €"],
                ["Cuisses", "120 €"],
            ]],
            ["Plusieurs zones", [
                ["Aisselles + avant-bras", "150 €"],
                ["Aisselles + demi-jambes", "150 €"],
                ["Aisselles + demi-jambes + avant-bras", "200 €"],
                ["Aisselles + jambes entières", "300 €"],
                ["Maillot classique + demi-jambes + aisselles", "220 €"],
                ["Maillot échancré + demi-jambes + aisselles", "240 €"],
                ["Maillot brésilien + demi-jambes + aisselles", "260 €"],
                ["Maillot intégral + demi-jambes + aisselles", "280 €"],
                ["Supplément sillon interfessier", "40 €"],
            ]],
        ],
    },
    pages: {
        conseils,
        tarifs: {
            eyebrow: "En toute transparence",
            h1: "Tarifs des consultations et des soins",
            lead: "Des prix clairs, annoncés avant de commencer. Pour tout acte de médecine esthétique, un devis écrit vous est remis, expliqué et décidé avec vous, avec un délai de réflexion.",
            consultationsTitle: "Consultations",
            consultationsNote:
                "La consultation est le préalable à tout soin : elle permet de poser le diagnostic, de vérifier les contre-indications et de construire le plan de prise en charge.",
            soinsTitle: "Soins de médecine esthétique",
            laserTitle: "Épilation laser, par zone",
            laserNote:
                "Prix par séance. Le nombre de séances dépend de la zone, de la densité et de la couleur du poil : il est estimé pendant la consultation, jamais promis à l'avance.",
            note: "Les actes de médecine esthétique ne sont pas remboursés par l'Assurance maladie. Les consultations médicales relèvent des conditions habituelles de prise en charge. Tarifs susceptibles d'évoluer : ceux annoncés en consultation font foi.",
        },
        medecin: {
            eyebrow: "Le médecin",
            h1: "Dr Souhali Massilia",
            lead: "Médecin fondatrice d'Aurassium Clinic, à Asnières-sur-Seine.",
            photoAlt: "Portrait du Dr Souhali Massilia, médecin fondatrice d'Aurassium Clinic",
            rpps: `N° RPPS ${SITE.rpps} · inscrite au tableau du Conseil départemental de l'Ordre des médecins des Hauts-de-Seine`,
            approcheTitle: "Son approche",
            approche: [
                "Médecine générale, médecine esthétique, médecine anti-âge et santé de la femme : ce cumul de formations permet de regarder un même signe sous plusieurs angles. Une acné qui résiste, une pilosité qui s'installe ou des cheveux qui s'affinent ne sont pas traités comme des problèmes isolés, mais rapportés à un terrain hormonal qui est d'abord exploré.",
                "Chaque prise en charge commence par un entretien et un examen clinique, suivis si nécessaire d'un bilan. Les options sont ensuite exposées avec leurs limites : ce qu'un traitement peut raisonnablement apporter, en combien de temps, et ce qu'il ne fera pas. Les actes sont réalisés ou supervisés par le médecin.",
            ],
            jobTitle: "Médecin généraliste, esthétique, anti-âge et santé de la femme",
            ctaTitle: "Consulter le Dr Souhali",
            ctaText: `Au cabinet, ${SITE.address}. Pour un premier rendez-vous, choisissez « première consultation ».`,
        },
        cabinet: {
            eyebrow: "Le lieu",
            h1: "Le cabinet, à Asnières-sur-Seine",
            lead: "Un cabinet calme, lumineux et chaleureux, pensé pour que vous soyez à l'aise dès l'entrée. Consultations et soins se déroulent sur place, dans un espace dédié.",
            photos: [
                ["accueil.jpg", "L'accueil du cabinet, avec son mur terracotta et son médaillon doré", "L'accueil", "50% 50%"],
                ["cafe.jpg", "Le coin café, avec une étagère en arche terracotta et un olivier", "Le coin café", "50% 50%"],
                ["peau.jpg", "Un olivier et deux cadres terracotta au mur", "Le coin olivier", "50% 50%"],
                ["bureau.jpg", "Une cabine de soins avec sa table de soin et les diplômes du médecin encadrés", "La cabine de soins", "50% 45%"],
                ["salle.jpg", "La salle de soins équipée pour l'épilation laser", "La salle de soins", "50% 50%"],
                ["mur.jpg", "Mur du cabinet, ambiance chaleureuse et lumineuse", "L'ambiance", "50% 50%"],
            ],
            surPlaceTitle: "Ce que vous trouverez sur place",
            surPlace: [
                "Le cabinet s'organise autour de trois espaces. L'accueil, d'abord, avec son mur terracotta : c'est là que l'on vous reçoit et que vous patientez, rarement longtemps, les rendez-vous étant espacés pour éviter l'attente. Un coin café est à votre disposition, avec de quoi vous asseoir tranquillement.",
                "Le bureau de consultation ensuite, où se déroulent l'entretien et l'examen clinique. C'est la pièce où l'on prend le temps : votre histoire, vos traitements, vos bilans, ce qui vous gêne au quotidien. Rien n'est décidé ni réalisé avant cet échange.",
                "La salle de soins enfin, équipée pour les actes réalisés au cabinet : épilation laser et électrolyse, peelings, mésothérapie, microneedling, injections. Le matériel y est à usage médical et les règles d'hygiène sont celles d'un cabinet médical, avec du matériel à usage unique pour tout ce qui doit l'être.",
            ],
            derouleTitle: "Le déroulé d'une visite",
            deroule: [
                "Une première visite commence toujours par une consultation. Elle sert à comprendre d'où vient ce qui vous amène — un déséquilibre hormonal, une peau qui réagit, une pilosité qui s'installe — avant d'envisager le moindre geste. Un bilan biologique peut être prescrit à l'issue de ce rendez-vous.",
                "Lorsqu'un acte esthétique est envisagé, il n'est jamais réalisé dans la foulée : un devis écrit vous est remis, expliqué, et un délai de réflexion est respecté. Vous repartez avec les informations nécessaires pour décider chez vous, sans pression.",
                "Les séances suivantes sont plus courtes et ciblées sur le soin convenu. Un rendez-vous de contrôle est proposé pour juger du résultat et ajuster la suite. Pour les traitements qui s'évaluent dans la durée — cheveux, mélasma, qualité de peau — des photographies sont prises au cabinet, dans les mêmes conditions d'éclairage, afin de comparer objectivement.",
            ],
            preparerTitle: "Préparer votre venue",
            preparerLead:
                "Quelques précautions simples permettent de tirer le meilleur parti du rendez-vous :",
            preparerItems: [
                "apportez vos derniers bilans sanguins et la liste de vos traitements, contraception comprise",
                "notez vos questions avant de venir : on les reprend une par une",
                "pour une séance d'épilation laser, rasez la zone la veille et évitez la cire et la pince dans les semaines précédentes",
                "évitez l'exposition solaire et les autobronzants avant un laser ou un peeling, et protégez la zone après",
                "venez démaquillée si un soin du visage est prévu",
                "signalez toute grossesse, allaitement ou traitement en cours : certains actes sont alors reportés ou contre-indiqués",
            ],
            preparerFin:
                "Vous pouvez venir accompagnée. Si vous devez annuler ou décaler, faites-le depuis Doctolib dès que possible : le créneau sera proposé à une autre patiente.",
            soinsTitle: "Les soins réalisés au cabinet",
            soinsLead:
                "Le cabinet d'Asnières-sur-Seine réunit deux activités complémentaires : la santé de la femme, avec les troubles hormonaux et leurs effets visibles sur la peau, les cheveux et la pilosité, et la médecine esthétique, qui vient corriger ces effets une fois la cause comprise. Les prises en charge les plus fréquentes au cabinet sont les suivantes :",
            soinsItems: {
                "epilation-laser": "poils du visage et du corps, hirsutisme",
                "acide-hyaluronique": "lèvres, cernes, volumes du visage",
                "peau-et-rides": "skinboosters, inducteurs de collagène, peelings, microneedling",
                melasma: "protocoles dépigmentants et photoprotection",
                acne: "prise en charge médicale et séquelles",
                "chute-de-cheveux": "bilan, mésothérapie du cuir chevelu",
                "sante-intime": "sécheresse intime et inconfort",
                sopk: "retentissement cutané et pileux",
                menopause: "peau, cheveux, confort intime",
            },
            soinsFin:
                "Tous ces soins sont pratiqués sur place, par le même médecin, du premier entretien jusqu'au rendez-vous de contrôle. Aucun acte n'est délégué et aucun n'est proposé sans indication médicale.",
            cadreTitle: "Un cadre médical, pas un institut",
            cadre: [
                "Aurassium Clinic est un cabinet médical tenu par le Dr Souhali Massilia, médecin inscrite au tableau de l'Ordre des médecins. Ce que vous confiez en consultation relève du secret médical, et le dossier constitué lors de votre venue n'est consulté que dans le cadre de votre suivi.",
                "Concrètement, cela change trois choses. Les produits utilisés sont des dispositifs à usage médical, tracés par numéro de lot. Les contre-indications sont systématiquement recherchées avant un acte : grossesse, allaitement, traitement photosensibilisant, antécédent cicatriciel, phototype. Et une demande peut être refusée ou reportée lorsque l'indication n'est pas réunie — un entretien n'engage jamais à un soin.",
                "Le cabinet n'assure pas de prise en charge des urgences. En cas d'urgence médicale, appelez le 15 ou le 112, ou rendez-vous au service d'urgences le plus proche.",
            ],
            adresseTitle: "Adresse et accès",
            adresse: [
                "Le cabinet se situe dans une rue calme d'Asnières-sur-Seine, accessible en transports en commun comme en voiture. Pensez à prévoir quelques minutes pour le stationnement aux heures de pointe.",
                "Merci d'arriver quelques minutes avant l'heure de votre rendez-vous, avec vos derniers bilans sanguins et la liste de vos traitements si vous en avez.",
            ],
            zoneTitle: "Qui vient au cabinet",
            zoneLead:
                "Les patientes viennent d'Asnières-sur-Seine et des communes voisines des Hauts-de-Seine, ainsi que du nord-ouest de Paris :",
            quartiers: [
                "Asnières-sur-Seine",
                "Clichy",
                "Bois-Colombes",
                "Courbevoie",
                "Levallois-Perret",
                "Gennevilliers",
                "Colombes",
                "Paris 17e",
            ],
            faqTitle: "Questions fréquentes sur le cabinet",
            faq: [
                [
                    "Comment se passe un premier rendez-vous au cabinet ?",
                    "Il commence par une consultation : entretien sur votre histoire et vos signes, puis examen clinique de la peau, des cheveux et de la pilosité. Un bilan peut être prescrit. Aucun acte esthétique n'est réalisé lors de ce premier rendez-vous.",
                ],
                [
                    "Que dois-je apporter ?",
                    "Vos derniers bilans sanguins si vous en avez, la liste de vos traitements en cours, contraception comprise, et vos questions. Pour un soin du visage, venez démaquillée.",
                ],
                [
                    "Puis-je venir accompagnée ?",
                    "Oui. L'accueil permet à la personne qui vous accompagne de patienter sur place pendant la consultation ou le soin.",
                ],
                [
                    "Le cabinet est-il accessible depuis les communes voisines ?",
                    "Le cabinet se situe au 10 rue Vladimir Kramnik, dans une rue calme d'Asnières-sur-Seine. Les patientes viennent aussi de Clichy, Bois-Colombes, Courbevoie, Levallois-Perret, Gennevilliers, Colombes et du 17e arrondissement de Paris.",
                ],
                [
                    "Quels sont les jours et horaires d'ouverture du cabinet ?",
                    "Le cabinet reçoit sur rendez-vous le lundi, le mardi, le jeudi et le vendredi, de 10h30 à 17h30. Il est fermé le mercredi, le samedi et le dimanche. Les créneaux réellement disponibles sont ceux affichés sur Doctolib, qui est mis à jour en temps réel.",
                ],
                [
                    "Comment prendre rendez-vous ?",
                    "La prise de rendez-vous se fait uniquement en ligne, via Doctolib. Vous y choisissez le motif — consultation de médecine esthétique, santé de la femme, épilation laser — puis le créneau qui vous convient. Vous recevez une confirmation et un rappel automatiques, et vous pouvez annuler ou décaler votre venue depuis le même espace.",
                ],
                [
                    "Les consultations et les soins sont-ils remboursés ?",
                    "Les actes de médecine esthétique ne sont pas pris en charge par l'Assurance maladie. Les tarifs sont annoncés à l'avance et détaillés sur la page tarifs ; pour tout acte esthétique, un devis écrit vous est remis avant la réalisation.",
                ],
                [
                    "Faut-il venir plusieurs fois pour un même traitement ?",
                    "Cela dépend du soin. Certains gestes se font en une séance, d'autres — épilation laser, électrolyse, mélasma, chute de cheveux, qualité de peau — demandent plusieurs séances espacées puis un entretien. Le nombre de séances envisagé vous est indiqué en consultation, avant toute décision.",
                ],
            ],
            moreBefore: "Pour aller plus loin : la page",
            moreTarifs: "tarifs",
            moreMiddle:
                "détaille le prix de chaque consultation et de chaque soin réalisé au cabinet, et la page",
            moreMedecin: "le médecin",
            moreAfter: "présente le parcours et les diplômes du Dr Souhali Massilia.",
        },
        soin: {
            faqTitle: "Questions fréquentes",
            ctaTitle: "Prendre rendez-vous",
            ctaText: `Consultation au cabinet, ${SITE.address}. Pour un premier rendez-vous, choisissez « première consultation ».`,
            relatedTitle: "À lire aussi",
            disclaimer:
                "Les informations de cette page sont données à titre d'information générale et ne remplacent pas une consultation médicale. Les résultats varient d'une personne à l'autre. Pour les actes esthétiques, un devis écrit est remis et un délai de réflexion est respecté.",
        },
        notfound: {
            eyebrow: "Erreur 404",
            h1: "Cette page n'existe pas",
            lead: "Le lien que vous avez suivi est peut-être incomplet. Voici où aller :",
            homeLink: "Retour à l'accueil",
        },
    },
    error: {
        h1: "Une erreur est survenue",
        text: "La page n'a pas pu s'afficher correctement. Rechargez-la, ou revenez à l'accueil.",
        reload: "Recharger la page",
        home: "Retour à l'accueil",
    },
    seo: {
        home: {
            title: "Médecine esthétique à Asnières-sur-Seine — Aurassium Clinic",
            description:
                "Dr Souhali Massilia, médecin esthétique, anti-âge et santé de la femme à Asnières-sur-Seine : épilation laser et électrolyse, acide hyaluronique, skinboosters, peelings, microneedling, SOPK et ménopause.",
        },
        tarifs: {
            title: "Tarifs — consultations, soins et épilation laser",
            description:
                "Tarifs 2026 du cabinet du Dr Souhali Massilia à Asnières-sur-Seine : consultation, SOPK, peelings, microneedling, skinbooster, acide hyaluronique, épilation laser par zone.",
        },
        medecin: {
            title: "Dr Souhali Massilia, médecin à Asnières-sur-Seine",
            description:
                "Dr Souhali Massilia, médecin fondatrice d'Aurassium Clinic à Asnières-sur-Seine : médecine esthétique, anti-âge et santé de la femme. Diplômes, formations et RPPS.",
        },
        cabinet: {
            title: "Le cabinet à Asnières-sur-Seine — accès et photos",
            description:
                "Le cabinet Aurassium Clinic, 10 rue Vladimir Kramnik à Asnières-sur-Seine : photos, accès, quartiers desservis et prise de rendez-vous en ligne.",
        },
        conseils: {
            title: "Conseils avant et après un soin — Aurassium Clinic",
            description:
                "Comment préparer une séance d'épilation laser, un peeling, un microneedling ou des injections, et quoi faire après : précautions, photoprotection et signes qui doivent faire reprendre contact.",
        },
        notfound: {
            title: "Page introuvable — Aurassium Clinic",
            description: "Cette page n'existe pas ou n'existe plus.",
        },
    },
};

export default fr;
